var _Observable_observers;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
class Observable {
    constructor() {
        _Observable_observers.set(this, void 0);
        __classPrivateFieldSet(this, _Observable_observers, new Map(), "f");
    }
    subscribe(subscriber) {
        const id = Symbol('id');
        __classPrivateFieldGet(this, _Observable_observers, "f").set(id, subscriber);
        const unsubscribe = () => {
            __classPrivateFieldGet(this, _Observable_observers, "f").delete(id);
        };
        return unsubscribe;
    }
    notify(value) {
        __classPrivateFieldGet(this, _Observable_observers, "f").forEach((subscriber) => subscriber(value));
    }
}
_Observable_observers = new WeakMap();
export default Observable;
//# sourceMappingURL=observable.js.map